// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationSidebar__sidebar___rJFog {
    --border-radius: calc(var(--control-radius) * 2);

    border-radius: 0 var(--border-radius) var(--border-radius) 0;
}

.NavigationSidebar__divider___ltBAU {
    --delimiter-size: 90%;

    margin: 0 var(--space-m);
}

.NavigationSidebar__buttons___Qlk84 {
    display: flex;
    flex-direction: column;
    gap: var(--space-3xs);
    padding: var(--space-m);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/NavigationSidebar/NavigationSidebar.css"],"names":[],"mappings":"AAAA;IACI,gDAAgD;;IAEhD,4DAA4D;AAChE;;AAEA;IACI,qBAAqB;;IAErB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B","sourcesContent":[".sidebar {\n    --border-radius: calc(var(--control-radius) * 2);\n\n    border-radius: 0 var(--border-radius) var(--border-radius) 0;\n}\n\n.divider {\n    --delimiter-size: 90%;\n\n    margin: 0 var(--space-m);\n}\n\n.buttons {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-3xs);\n    padding: var(--space-m);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `NavigationSidebar__sidebar___rJFog`,
	"divider": `NavigationSidebar__divider___ltBAU`,
	"buttons": `NavigationSidebar__buttons___Qlk84`
};
export default ___CSS_LOADER_EXPORT___;
